import { render, staticRenderFns } from "./MailTemplateInput.vue?vue&type=template&id=86ac82f0&"
import script from "./MailTemplateInput.vue?vue&type=script&lang=ts&"
export * from "./MailTemplateInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports